"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useSwipeableCarousel = require("./useSwipeableCarousel");
Object.keys(_useSwipeableCarousel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useSwipeableCarousel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useSwipeableCarousel[key];
    }
  });
});